import { Cookies } from '@egw/clients'
import { produce } from 'immer'
import { type RecoveryFlow } from '../../models'

const STORAGE_KEY = 'recovery-flow'

export const setRecoveryFlowData = (data: RecoveryFlow): void => {
  Cookies.set(STORAGE_KEY, data)
}

export const updateRecoveryFlowData = (mtFn: (_data: RecoveryFlow) => void): RecoveryFlow | undefined => {
  const d = getRecoveryFlowData()
  if (d) {
    const data = produce(d, (draft) => {
      mtFn(draft)
    })
    Cookies.set(STORAGE_KEY, data)
    return data
  }
}

export const getRecoveryFlowData = (): RecoveryFlow | undefined => {
  return Cookies.get(STORAGE_KEY) as RecoveryFlow
}

export const removeRecoveryFlowData = (): void => {
  Cookies.remove(STORAGE_KEY)
}
